import { render, staticRenderFns } from "./CustomerAnalysis.vue?vue&type=template&id=dddd08a0"
import script from "./CustomerAnalysis.vue?vue&type=script&lang=js"
export * from "./CustomerAnalysis.vue?vue&type=script&lang=js"
import style0 from "./CustomerAnalysis.vue?vue&type=style&index=0&id=dddd08a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports